module.exports = __webpack_public_path__ + "static/kathmantour-e677302567ce2d9c6cad1d67391fdd32.png";